import AbstractEntryCommand from "./AbstractEntryCommand.js";
import getNamedCommandHeading from "../getNamedCommandHeading.js";

/**
 * `importCommand` is the command used to import an exported folder structure
 * from another archive.
 * `importCommand` is valid if and only if the current user is backoffice user
 */
export default class ImportCommand extends AbstractEntryCommand {
	constructor() {
		super(...arguments);

		this._name = "";
	}

	getName() {
		return this._name;
	}

	setName(newName) {
		this._name = newName;
	}

	accept(aVisitor) {
		return aVisitor.visitImportCommand(this);
	}

	requireRefresh() {
		return true;
	}

	heading() {
		return getNamedCommandHeading("Administrative");
	}

	priority() {
		return 200;
	}

	uploadPath() {
		return this._documentService.uploadPath();
	}

	_performOnService(callback) {
		this._documentService.executeImportCommand(this, callback);
	}

	_execute() {}

	static isApplicable(context) {
		return this.shouldShowAdminCommands(context);
	}
}
